export const UPLOAD_CSV_CLIENTS_MESSAGES = {
  CREATED: 'The csv file was successfully uploaded',
};


// WEBPACK FOOTER //
// ./src/features/score-card/constants/uploadCsvClientsMessages.js